import { ArrowDown } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ArrowDownIcon = createLucideIcon(ArrowDown);
